import { CommonSliceType } from '../../../../types/slice';
import { toRichTextFromProp, toTextFromProp } from '../../fields/text';

export const titleSlice = ({ primary }) => ({
  type: CommonSliceType.SUBTITLE,
  value: toTextFromProp('title', primary),
});

export const deprecatedSubtitleSlice = ({ primary }) => ({
  type: CommonSliceType.SUBTITLE,
  value: toTextFromProp('subtitle', primary),
});

export const heading2Slice = ({ primary }) => ({
  type: CommonSliceType.HEADING,
  value: toTextFromProp('text', primary),
});

export const deprecatedChapeauSlice = ({ primary }) => ({
  type: CommonSliceType.CHAPEAU,
  value: toTextFromProp('chapeau', primary),
});

export const chapeauSlice = ({ primary }) => ({
  type: CommonSliceType.CHAPEAU,
  value: toTextFromProp('text', primary),
});

export const deprecatedHeadingSlice = ({ primary }) => ({
  type: CommonSliceType.HEADING,
  value: toTextFromProp('heading', primary),
});

export const textSlice = ({ primary }) => ({
  type: CommonSliceType.TEXT,
  body: toRichTextFromProp('text', primary),
});

export const deprecatedTextSlice = ({ primary }) => ({
  type: CommonSliceType.TEXT,
  body: toRichTextFromProp('txt', primary),
});
